module.exports = __webpack_public_path__ + "static/media/attach.df46a52d.svg";